import { FunctionComponent, PropsWithChildren } from "react";

import * as Styled from "./styles";

interface ContainerProps extends PropsWithChildren {
  fullHeight?: boolean;
}

const Container: FunctionComponent<ContainerProps> = ({ fullHeight = false, children }: ContainerProps) => {
  return <Styled.ContainerDiv $fullHeight={fullHeight}>{children}</Styled.ContainerDiv>;
};

export default Container;
